module.exports = __webpack_public_path__ + "img/Vintage.913f417.jpg";